import { render, staticRenderFns } from "./Advertisement.vue?vue&type=template&id=220524b6"
import script from "./Advertisement.vue?vue&type=script&lang=ts"
export * from "./Advertisement.vue?vue&type=script&lang=ts"
import style0 from "./Advertisement.vue?vue&type=style&index=0&id=220524b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports